<template >
    <div class="people_set">
      <el-upload class="upload-demo" :action="action" :file-list="fileList" :auto-upload="autoUpload" :on-progress="getProgress" :before-upload="handleUpload" :on-success="handleAvatarSuccess" :on-error="handleAvatarError" list-type="picture">
        <div class="upload_btn">
          <el-button size="small" type="primary"><i class="el-icon-upload el-icon--left"></i>上传头像</el-button>
          <div slot="tip" class="el-upload__tip">支持jpg/jpeg/png类型，且不超过500KB</div>
          <el-progress v-if="percentage>0" :show-text="true" :title="title" :percentage="percentage"></el-progress>
        </div>
      </el-upload>
      <div class="input_style">
        <div class="font_style_set">员工编号:</div>
        <Input v-model="employeeCode" :disabled="disabled" placeholder="请输入员工编号"/>
      </div>
      <div v-show="'0' == agentInfo.employeeType" class="input_style">
        <div class="font_style_set">话机设置:</div>
        <Select v-model="phoneSet" placeholder="话机设置">
            <!-- <Option v-for="item in phoneSetBase" :value="item.key" :key="item.key">{{ item.value}}</Option> -->
	          <Option  v-for="item in phoneSetBaseA" :value="item.key" :key="item.key" v-if="registeredCertificate=='1'&&externalPhoneAutoAnswer=='1'">{{ item.value}}</Option>
            <Option  v-for="item in phoneSetBase" :value="item.key" :key="item.key" v-if="registeredCertificate=='1'&&externalPhoneAutoAnswer=='0'">{{ item.value}}</Option>
            <Option  v-for="item in phoneSetBaseB" :value="item.key" :key="item.key" v-if="registeredCertificate=='0'&&externalPhoneAutoAnswer=='1'">{{ item.value}}</Option>
            <Option  v-for="item in phoneSetBaseC" :value="item.key" :key="item.key" v-if="registeredCertificate=='0'&&externalPhoneAutoAnswer=='0'">{{ item.value}}</Option>
        </Select>
        <Tooltip class="tips_font" placement="top" content="话机从内置切换成外置或外置切换成内置时，需要重新签入座席"><img :src="questionMark"/></Tooltip>
      </div>
      <div v-show="('0' == phoneSet || '4' == phoneSet) && '0' == agentInfo.employeeType" class="input_style">
        <div class="font_style_set">外置话机页面接听:</div>
        <Select v-model="outPhonePick" >
          <Option v-for="item in openList" :value="item.id" :key="item.id">{{ item.name}}</Option>
        </Select>
        <Tooltip class="tips_font" placement="top" content="开启外置话机页面接听功能，需要您的外置话机支持，才可正常使用"><img :src="questionMark"/></Tooltip>
      </div>
      <div v-show="'0' == agentInfo.employeeType" class="input_style">
        <div class="font_style_set">挂断后状态:</div>
        <Select v-model="agentStatus" clearable placeholder="请选择挂断后状态">
          <Option v-for="item in agentStatusList" :value="item.id" :key="item.id" :disabled="item.disabled">{{ item.name}}</Option>
        </Select>
      </div>
      <div class="input_style">
        <div class="font_style_set">手机号码:</div>
        <Input v-model="employeeMobile" placeholder="请输入手机号码"/>
      </div>
      <div class="input_style">
        <div class="font_style_set">员工邮箱:</div>
        <Input v-model="employeeEmail" placeholder="请输入员工邮箱"/>
      </div>
      <div v-show="'0' == agentInfo.employeeType" class="input_style">
        <div class="font_style_set">自动签入设置:</div>
        <Select v-model="autoSignIn" clearable placeholder="请选择是否自动签入">
          <Option v-for="item in judgeList" :value="item.id" :key="item.id">{{ item.name}}</Option>
        </Select>
      </div>
      <div class="input_style" style="display: block">
        <div  v-show="'0' == agentInfo.employeeType" class="font_style_set" style="float:left;">热线号码:</div>
        <Select  v-show="'0' == agentInfo.employeeType" v-model="pstnNumber" clearable placeholder="请选择热线号码">
          <Option v-for="(item,index) in pstnNumberList" :value="item.pstnNumber" :key="index">{{ item.pstnNumber}}</Option>
        </Select>
        <div style="width: 100%;height: 10px"></div>
        <Button type="success" class="submit_btn" long @click="save">保 存</Button>
      </div>
    </div>
</template>

<script>
    import {publicFunClass} from '@/components/js/PublicFunClass.js'
    export default {
        name: "PeopleSetting",
        mixins:[publicFunClass],
        props:{
          showPeopleSetting:Boolean,
          pageCode:String
        },
        data() {
          return {
            outPhonePick:'0',
            showPageCount:0,
            agentStatus:'-1',
            questionMark:require('../../assets/image/homeAsk.png'),
            agentStatusList:[{'id': '0', 'name': '空闲'},{'id': '4', 'name': '后处理'},{'id': '8', 'name': '仅呼出'}],
            fileList: [{name: 'food.jpeg', url: require('../../assets/image/customerService.png')}],
            percentage:0,
            action:this.baseURL+"common/upload.json?type=head&companyNo="+localStorage.getItem("companyId"),
            title:"头像上传中",
            employeeCode:'',
            phoneSetBase:[{'key':'0','value':'外置'},{'key':'1','value':'内置'},{'key':'2','value':'内置呼出自动接听'},{'key':'3','value':'内置全部自动接听'}],
	          phoneSetBaseA:[{'key':'0','value':'外置'},{'key':'4','value':'外置呼出自动接听'},{'key':'1','value':'内置'},{'key':'2','value':'内置呼出自动接听'},{'key':'3','value':'内置全部自动接听'}],
            phoneSetBaseB:[{'key':'0','value':'外置'},{'key':'4','value':'外置呼出自动接听'}],
            phoneSetBaseC:[{'key':'0','value':'外置'}],
            phoneSet:"0",
            employeeMobile:'',
            disabled:true,
            autoUpload:true,
            id:'',
            file:'',
            employeeEmail:'',
            pstnNumberList:[],
            pstnNumber:'',
            imagePath:'',
            autoSignIn:'0',
            judgeList:[{'id':'0','name':'否'},{'id':'1','name':'是'}],
            openList:[{'id':'0','name':'关闭'},{'id':'1','name':'开启'}],
            employeeHead:[{'result':''}],
            configInfo: JSON.parse(localStorage.getItem("configInfo")),
	          registeredCertificate:localStorage.getItem("registeredCertificate"),
            externalPhoneAutoAnswer:localStorage.getItem("externalPhoneAutoAnswer"),
            agentInfo: JSON.parse(localStorage.getItem("agentInfo")),
          };
        },
        methods:{
          handleUpload(file){
            let fileSize=parseInt(file.size/1024);
            let type=file.name.substr(file.name.length-4,4);
            if (!(type.indexOf("jpg")!=-1 || type.indexOf("jpeg")!=-1 || type.indexOf("png")!=-1)) {
              this.$Modal.info({
                title:'提示',
                content:"文件"+file.name+"类型必须为jpg/jpeg/png"
              });
              return false;
            }
            if (fileSize>500) {
              this.$Modal.info({
                title:'提示',
                content:"文件"+file.name+"尺寸太大,头像不能超过500KB"
              });
              return false;
            }
          },
          getProgress(event){
            this.percentage=parseInt(event.percent.toFixed(2));
          },
          handleAvatarError(err, file, fileList){
            this.title="上传失败";
            this.percentage=err;
          },
          handleAvatarSuccess(response, file, fileList) {
            this.fileList=[];
            let param={
              name:file.name,
              url:file.url,
              status:file.status,
            };
            this.fileList.push(param);
            if (response.flag!="666") {
              this.$Modal.info({
                title:'提示',
                content:response.msg
              });
              this.title="上传失败";
              this.percentage=0;
              return false;
            }
            this.imagePath=response.obj.absolutePath;
            this.title="已上传完成";
          },
          save:function(){
            if(this.employeeMobile && !(/^1[34578]\d{9}$/.test(this.employeeMobile))){
              this.$Message.info("手机号码格式错误!请重新输入");
              return false;
            }
            let newPhoneSet = this.phoneSet;
            if(!newPhoneSet){
              this.$Message.error("话机设置为空，请选择！");
              return false;
            }
            let param={
              id:this.id,
              agentStatus:this.agentStatus?this.agentStatus:"",
              employeeHead:this.imagePath,
              employeeMobile:this.employeeMobile,
              employeeEmail:this.employeeEmail,
              phoneSet:this.phoneSet,
              isPstnNumber:this.pstnNumber?this.pstnNumber:"",
              autoSignIn:this.autoSignIn,
              journalType:"个人设置编辑",
              menuId:"null",
              externalAnswer:this.outPhonePick
            };
            let that=this;
            this.$http.post("personal/doSave.json",param) .then(function (res) {
              let result=res.data.flag;
              if(result!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }
              that.$Message.info("保存成功");
              that.initSearch();
            });
          },
          initSearch:function () {
            let that=this;
            let param={
              journalType:"null",
              menuId:"null"
            };
            this.$http.post("personal/toIndex.json",param) .then(function (res) {
              let result=res.data.flag;
              if(result!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }
              let obj=res.data.obj;
              that.employeeCode=obj.employeeCode;
              that.agentStatus=obj.agentStatus;
              that.autoSignIn=obj.autoSignIn;
              that.phoneSet=obj.phoneSet;
              that.employeeMobile=obj.employeeMobile;
              that.employeeEmail=obj.employeeEmail;
              that.outPhonePick=obj.externalAnswer;
              that.pstnNumberList=[];
              if(obj.pstnNumber && obj.pstnNumber!="null"){
                let newParamList=obj.pstnNumber.split(",");
                for(let i=0;i<newParamList.length;i++){
                  let param={
                    pstnNumber:newParamList[i]
                  };
                  that.pstnNumberList.push(param);
                }
              }
              that.pstnNumber=obj.isPstnNumber;
              localStorage.setItem("pstnNumber",obj.isPstnNumber);//热线号码v
              localStorage.setItem("phoneType",obj.phoneSet);//话机设置
              localStorage.setItem("outPhonePick",obj.externalAnswer);//外置话机页面接听v
              localStorage.setItem("autoSignIn",obj.autoSignIn);//自动签入设置v
              localStorage.setItem("hangupAgentStatus",obj.agentStatus);//挂断后状态v
              that.imagePath=obj.employeeHead;
              that.id=obj.id;
              if(obj.employeeHead && obj.employeeHead!="null"){
                that.fileList[0].url=that.baseImgURL+obj.employeeHead;
              }
            });
          }
        },
        created(){
          let agentState=this.configInfo.agentState;
          if(agentState){
            agentState=agentState.split(",");
            for (let i=0;i<agentState.length;i++){
              let id=agentState[i];
              for (let k=0;k<this.agentStatusList.length;k++){
                if(id==this.agentStatusList[k].id){
                  this.agentStatusList[k].disabled=true;
                }
              }
            }
          }
        },
        mounted() {
                this.initSearch()
        },
        watch:{
          pageCode:{
            deep:true,
            handler() {
              if (this.pageCode == '4_4') {
                this.initSearch()
              }
            }
          },
          showPeopleSetting:{
            deep:true,
            handler() {
              if (this.showPeopleSetting) {
                this.initSearch()
              }
            }
          },

        }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/myWorkbench/PeopleSetting.vue